import React, { useEffect } from 'react';
import { ToastContainer, Toast } from 'react-bootstrap';
import { useToast } from '../contexts/ToastContext';

const ToastNotification = () => {
  const { toast, hideToast } = useToast();

  useEffect(() => {
    if (toast.show) {
      setTimeout(() => {
        hideToast();
      }, 5000);
    }
  }, [toast, hideToast]);

  return (
    <ToastContainer
      position="top-end"
      className="position-fixed p-3"
      style={{
        top: '10px',
        right: '10px',
        zIndex: 10500,
      }}
    >
      {toast.show && (
        <Toast
          className={`align-items-center text-white ${toast.type === 'error' ? 'bg-danger' : 'bg-success'}`}
          autohide
          delay={5000}
        >
          <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
      )}
    </ToastContainer>
  );
};

export default ToastNotification;
